import React from 'react';

export default function Login() {
  const frontendOrigin = window.location.origin;
  const googleAuthUrl = "https://developerapi.dbtouch.com/googleAuth?origin=" + encodeURIComponent(frontendOrigin);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4">
      
      {/* Glavna kartica za prijavu */}
      <div className="max-w-sm w-full bg-slate-900 border border-slate-800 p-8 rounded-3xl shadow-2xl text-center space-y-6">
        
        {/* LOGOTIP I NASLOV SUSTAVA */}
        <div className="flex flex-col items-center gap-3">
          <div className="w-14 h-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center text-white shadow-inner">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 100 100" 
              className="w-9 h-9 text-white"
            >
              <path d="M 10 90 L 90 90" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
              <path d="M 65 90 L 65 44 L 75 32 L 85 44 L 85 90" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
              <path d="M 55 90 L 55 64 L 65 54" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
              <path d="M 85 54 L 95 64 L 95 90" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
              <line x1="70" y1="52" x2="70" y2="56" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              <line x1="70" y1="62" x2="70" y2="66" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              <line x1="70" y1="72" x2="70" y2="76" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              <line x1="70" y1="82" x2="70" y2="86" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              <line x1="80" y1="52" x2="80" y2="56" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              <line x1="80" y1="62" x2="80" y2="66" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              <line x1="80" y1="72" x2="80" y2="76" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              <line x1="80" y1="82" x2="80" y2="86" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              <line x1="90" y1="70" x2="90" y2="74" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              <line x1="90" y1="80" x2="90" y2="84" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              <path d="M 10 68 L 28 50 L 38 64 L 55 48" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
              <path d="M 46 48 L 55 48 L 55 57" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
              <path d="M 18 90 L 18 78 L 24 78 L 24 90" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
              <path d="M 30 90 L 30 74 L 36 74 L 36 90" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </svg>
          </div>

          <div>
            <h1 className="text-xl font-extrabold text-white tracking-tight uppercase">DEVELOPER ERP</h1>
            <p className="text-xs text-slate-400 mt-0.5">Sustav za vođenje projekata i prodaje</p>
          </div>
        </div>

        {/* GUMB ZA GOOGLE PRIJAVU */}
        <div className="pt-2">
          <a 
            href={googleAuthUrl} 
            className="flex items-center justify-center gap-3 w-full bg-white hover:bg-slate-100 active:scale-[0.98] text-slate-900 font-bold text-xs py-3 px-4 rounded-xl shadow-lg transition duration-150 cursor-pointer"
          >
            {/* Google SVG Logo */}
            <svg className="w-4 h-4 shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24s.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
              <path fill="none" d="M0 0h48v48H0z"/>
            </svg>
            <span>Prijava putem Google računa</span>
          </a>
        </div>

        <p className="text-[11px] text-slate-500 font-medium">
          Siguran pristup rezerviran za ovlaštene članove tima
        </p>

      </div>
    </div>
  );
}